'use strict';

function _TradeController() {
  this.id = null;
  this.node = null;
  this.extends = [_AccountController];
  this.declaredClass = null;

  this._tradeProfileModelReady = $.Deferred();
  this._indexTradeProfilesAction = 'account.index_trade_profiles';

  this.init = function () {
    this._super();

    this._productSettings = new ProductSettings(this.presenter);
    this._createTradeModel();
    $.when(this._tradeProfileModelReady).then(this.initPage.bind(this));
  };

  this._createTradeModel = function () {
    if (typeof this.presenter.models.tradeProfile === 'undefined' || !this.presenter.models.tradeProfile._initialized) {
      if (this.presenter.hasAction(this._indexTradeProfilesAction)) {
        this.presenter.performAction(this._indexTradeProfilesAction, null, this._onCreateTradeProfileModel.bind(this));
      } else {
        console.warn('cannot retrieve trade profile: missing index trade profile link');
      }
    } else {
      this._tradeProfileModelReady.resolve();
    }
  };

  this._onCreateTradeProfileModel = function (data, response) {
    // Checks for Connection issue
    if (this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized || this.declaredClass !== this._currentClass) {
        this._currentClass = this.declaredClass;
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: this._indexTradeProfilesAction }, { productLabel: 'Trade' }, null, this._connectionIssueConfig);
      }
    } else if (response === 200) {
      this.presenter.createModel('tradeProfile', { data: data });
      this._tradeProfileModelReady.resolve();
    } else {
      console.warn('_onCreateTradeProfileModel - Error calling ' + this._indexTradeProfilesAction + ' rel link:');
    }
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {};
}